import React from 'react';
import { functions } from 'constantes';
import CardElemento from './CardElemento';

const ElementoElaboracionPlanDeMedios = ({nombreDelMedio, asignarPlanDeMedio, idTipoMedioDeComunicacion, datosDelMedio}) => {
  return (
    <>
      <CardElemento idTipoMedioDeComunicacion={idTipoMedioDeComunicacion}
      datosDelMedio={ {...datosDelMedio, nombreMedio: nombreDelMedio, idEleccion: 1, tipoCandidatura: "PRESIDENCIA"}} asignarPlanDeMedio={asignarPlanDeMedio} />
      <CardElemento idTipoMedioDeComunicacion={idTipoMedioDeComunicacion}
      datosDelMedio={{...datosDelMedio, nivelCobertura: functions.ordenarArreglo(datosDelMedio.nivelCobertura, 'id'), nombreMedio: nombreDelMedio, idEleccion: 2, tipoCandidatura: "CORPORACIONES MUNICIPALES"}}
      asignarPlanDeMedio={asignarPlanDeMedio} />
      <CardElemento idTipoMedioDeComunicacion={idTipoMedioDeComunicacion} datosDelMedio={{...datosDelMedio, nombreMedio: nombreDelMedio, idEleccion: 3, tipoCandidatura: "DIPUTACIONES"}} asignarPlanDeMedio={asignarPlanDeMedio} />
    </>
  );
}

export default ElementoElaboracionPlanDeMedios;